export const CUE_COMPLIANCE_UPSELL_CTA = {
  ctaId: 'workflows_compliance_upsell_cta',
  viewEvent: 'workflows:cue_compliance_upsell_button_view',
  clickEvent: 'workflows:cue_compliance_upsell_button_click',
  // Fired on the card's own Close button, not routed through CueCtaButton
  // (which only knows view/click). Without it, an ignored card and a
  // dismissed one are both just an absence of a click.
  closeEvent: 'workflows:cue_compliance_upsell_button_close',
} as const;
